import React, { useContext, useState } from "react";

//import context
import { MyContext } from "../../../../tenantsDashContext";

//import icons

import { RiMessage2Line } from "react-icons/ri";
import { RxDashboard } from "react-icons/rx";
import { FaUsers } from "react-icons/fa";
import { MdPayment } from "react-icons/md";

//import css
import "./Mobile-Nav.scss";

const MobileNav = () => {
  const { sharedValue, setSharedValue } = useContext(MyContext);
  const [activeNavItem, setActiveNavItem] = useState("Overview"); // Set the default active item

  const handleNavClick = (item) => {
    setActiveNavItem(item);
    setSharedValue(item);
    console.log("Shared Value:", sharedValue);
  };

  return (
    <nav className="mobile-nav">
      <button onClick={() => handleNavClick("Overview")}>
        <div
          className={`nav-item ${
            activeNavItem === "Overview" ? "nav-item-active" : ""
          }`}
        >
          <RxDashboard size={24} />
          <span className="nav-text">Overview</span>
        </div>
      </button>
      <button onClick={() => handleNavClick("Tenants")}>
        <div
          className={`nav-item ${
            activeNavItem === "Tenants" ? "nav-item-active" : ""
          }`}
        >
          <FaUsers size={24} />
          <span className="nav-text">Tenants</span>
        </div>
      </button>
      <button onClick={() => handleNavClick("Payments")}>
        <div
          className={`nav-item ${
            activeNavItem === "Payments" ? "nav-item-active" : ""
          }`}
        >
          <MdPayment size={24} />
          <span className="nav-text">Payments</span>
        </div>
      </button>
      <button onClick={() => handleNavClick("Messages")}>
        <div
          className={`nav-item ${
            activeNavItem === "Messages" ? "nav-item-active" : ""
          }`}
        >
          <RiMessage2Line size={24} />
          <span className="nav-text">Messages</span>
        </div>
      </button>
    </nav>
  );
};

export default MobileNav;
